import { CreditCardIcon } from "lucide-react";
import { PlanBadge, useWorkingCopyPlan } from "./PlanBadge.js";

type Props = {
	onOpenBilling: () => void;
};

/** Opens Settings → Billing. Plan status comes from Clerk, not a stub meter. */
export function SidebarUsage({ onOpenBilling }: Props) {
	const { pro } = useWorkingCopyPlan();

	return (
		<button
			type="button"
			className="side-usage"
			onClick={onOpenBilling}
			aria-label="Open billing"
		>
			<span className="side-usage-top">
				<span className="side-usage-label">
					<CreditCardIcon className="size-3.5" />
					Billing
				</span>
				<PlanBadge />
			</span>
			<span className="side-usage-sub">
				<span>
					{pro ? "Working copy is on" : "Pay as you go or monthly"}
				</span>
			</span>
		</button>
	);
}
